import { isPlainObject } from "lodash";

import { useTypedSelector } from "../hooks";
import { CartState } from "../slices/cartSlice";

export const useCart = (): CartState =>
  useTypedSelector(({ cart }) => (isPlainObject(cart) ? cart : null));
